// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jk-3";
export var downloadButton = "_jk-4";
export var fileContainer = "_jk-9 _jk-7";
export var fileContainerBase = "_jk-7";
export var fileContainerFixedHeight = "_jk-8 _jk-7";
export var fileInfo = "_jk-5";
export var fileInfoWidthRestricted = "_jk-6";
export var fileType = "_jk-1";
export var fileTypeName = "_jk-2";
export var image = "_jk-0";
export var link = "_jk-b";
export var overflowEllipsis = "_jk-a";